var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flexCol alit justc",staticStyle:{"position":"relative","width":"100%","height":"100%"}},[_c('div',{staticStyle:{"width":"100%","height":"100%","position":"relative","z-index":"9"},attrs:{"id":"bottomRight"}}),_c('img',{staticClass:"bg",attrs:{"src":"https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/bottom/jinbi2.png"}})])])
}]

export { render, staticRenderFns }